import { QuestionCircleFill } from "react-bootstrap-icons";
import { NavLink } from "react-router-dom";
import { cn } from "@utils";

// Full brand mark: the orange slash followed by the "ontik" wordmark. The slash sits at the very
// left so a fixed-width clip can show just the slash when collapsed and reveal the word as the
// rail expands — the slash never moves. The slash blinks (logoblink) in both states.
function OntikLogo() {
  return (
    <svg
      viewBox="0 0 586 282"
      width="58"
      height="28"
      style={{ display: "block" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <polygon
        points="59,61 88,61 48,237 18,237"
        fill="#F25303"
        className="logo-slash"
      />
      <text
        x="118"
        y="199"
        fontFamily="'Hanken Grotesk', sans-serif"
        fontWeight="900"
        fontSize="192"
        letterSpacing="-9.6"
        fill="#1B1813"
      >
        ontik
      </text>
    </svg>
  );
}

export function SidebarFooter({ collapsed = false, onNavigate }) {
  return (
    <div className="mt-auto flex items-center justify-between p-4 text-zinc-400">
      {/* Clip to just the slash when collapsed; widen to the full logo as the rail expands. The
          translateZ(0) puts this subtree (with its perpetual logo blink) on its own compositing
          layer, so Safari confines the animation's repaints here rather than dropping unrelated
          content until a hover forces a repaint. */}
      <div
        style={{ transform: "translateZ(0)" }}
        className={cn(
          "ml-[5px] shrink-0 overflow-hidden transition-[width] duration-300 ease-in-out",
          collapsed ? "w-3" : "w-[58px]",
        )}
      >
        <OntikLogo />
      </div>
      <NavLink
        className={cn(
          "shrink-0 text-base transition-opacity duration-200 ease-in-out",
          collapsed ? "pointer-events-none opacity-0" : "opacity-100",
        )}
        onClick={onNavigate}
        to="/support"
        tabIndex={collapsed ? -1 : undefined}
        aria-hidden={collapsed}
      >
        <QuestionCircleFill className="text-base" />
      </NavLink>
    </div>
  );
}
